BuyButton = window.BuyButton ?= {}

MagicEventBus = require 'magic-event-bus/lib/frizzle.js'
BuyButton.View = require './views/buy_button'

resetMultiOptionLink = ->
  $(window).on 'pageshow', ->
    if $('.multi-option-breakout').length
      $wrapper = '.multi-option-breakout'
      $buyLink = $('#buy-link').attr('href')
    else
      $wrapper = '#options'
      $buyLink = $('#options a.buy-button').attr('href')

    $($wrapper + ' input[value="' + $buyLink + '"]').prop('checked', true)

BuyButton.init = ({buyButton, iframeLogin}, done) ->
  @eventBus = new MagicEventBus()

  if iframeLogin? and not iframeLogin.authenticated and not iframeLogin.disabledOnBuyButton
    handleBuyButton = ->
      IframeLogin.openModal BuyButton.view.$buyButton.attr 'href'
      {stopTheBus: true}

    @eventBus.board('buy_button_clicked', handleBuyButton)(999)

  $ =>
    if buyButton.multiOptionEnabled
      resetMultiOptionLink()

    @view = new BuyButton.View
      multiOptionEnabled: buyButton.multiOptionEnabled
      multiOptionInline: buyButton.multiOptionInline

    done()

module.exports = BuyButton
